import * as userActions from 'actions/userActions'

import { compose, withHandlers, lifecycle } from 'recompose'
import withMixpanel, { SCREEN_VIEW_EDIT_PROFILE } from 'utils/mixpanel'

import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { isEqual, getSplitName } from 'utils/misc'

export default compose(
  withMixpanel,
  connect(
    // mapStateToProps
    (state) => {
      return {
        hasError: idx(state, _ => _.progress.login.hasError) || false,
        errorMessage: idx(state, _ => _.progress.login.error.message) || null,
        initialValues: {
          name: idx(state, _ => _.user.fullName),
          email: idx(state, _ => _.user.email)
        }
      }
    },
    // mapDispatchToProps
    (dispatch) => {
      const actions = {
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onFormSubmit: ({ initialValues, history, actions }) => (editFields) => {
      // TODO: update user information here
      if (isEqual(editFields, initialValues)) {
        history.goBack()
      } else {
        actions.updateUser({name: editFields.name, email: editFields.email}, editFields.email !== initialValues.email)
      }
    },
    onBackPress: ({ history }) => () => {
      history.goBack()
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.track(SCREEN_VIEW_EDIT_PROFILE)
    }
  })
)



// WEBPACK FOOTER //
// ./src/containers/account/EditDetails/EditDetails.enhancer.js